import {FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select} from '@mui/material';
import {useFetch} from '../hooks/useFetch';

export default ({value, error, handleBlur, handleChange, ...props}) => {
    const {data, mutate, error: err} = useFetch('team', {status: true});

    return (
        <Grid item xs={12} md={12}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Função</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value}
                    label="Sexo"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    {...props}>
                    {data?.map(item => (
                        <MenuItem key={`team-${item.id}`} value={item.id}>{item.name}</MenuItem>
                    ))}
                </Select>
                <FormHelperText>{error}</FormHelperText>
            </FormControl>
        </Grid>
    );
};
